import { render, staticRenderFns } from "./AvatarStack.vue?vue&type=template&id=2248146d&scoped=true"
import script from "./AvatarStack.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarStack.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AvatarStack.vue?vue&type=style&index=0&id=2248146d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2248146d",
  null
  
)

export default component.exports